
export default {
  SET_TASKS (state, tasks) {
    state.tasks = tasks
  },
  SET_HISTORIS (state, historis) {
    state.historis = historis
  },
  ADD_PERSEDIAAN (state, payload) {
    state.historis.unshift(payload)
    payload.items.forEach((item) => {
      const itemIndex = state.tasks.findIndex((task) => task.id === parseInt(item.task_name))
      const kredit = parseInt(state.tasks[itemIndex].kredit) + parseInt(item.task_quantity)
      state.tasks.find((task) => task.id === parseInt(item.task_name)).kredit = kredit
    });
  },
  UPDATE_PERSEDIAAN (state, items) {
    const persediaanIndex = state.historis.findIndex((p) => p.task_parent === items.persediaan.task_parent)
      Object.assign(state.historis[persediaanIndex], items.persediaan)
    items.pemindahan.forEach((item) => {
      const itemIndex = state.tasks.findIndex((task) => task.id === parseInt(item.task_name))
      const kredit = parseInt(state.tasks[itemIndex].kredit) + parseInt(item.task_quantity)
      state.tasks.find((task) => task.id === parseInt(item.task_name)).kredit = kredit
    });
  },
  REMOVE_PERSEDIAAN (state, payload) {
    const ItemIndex = state.historis.findIndex((p) => p.id === payload.id)
    state.historis.splice(ItemIndex, 1)
    /*
    payload.items.forEach((item) => {
      const itemIndex = state.tasks.findIndex((task) => task.id === parseInt(item.task_name))
      const kredit = parseInt(state.tasks[itemIndex].kredit) - parseInt(item.task_quantity)
      state.tasks.find((task) => task.id === parseInt(item.task_name)).kredit = kredit
    });
    */
  }
}
